import {useContext, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {UserContext} from 'contexts/UserContext'
import Sidebar from '../Sidebar/Sidebar'
import NotificationsSidebar from 'components/NotificationsSidebar'
import hamburgerIcon from 'assets/img/hamburger.svg'
import closeIcon from 'assets/img/close-icon.svg'
import logo from 'assets/img/logo-white-mobile.svg'
import {getItemFromStorage} from 'utils/storage'

const Layout = ({children}) => {
  const user = getItemFromStorage({name: 'user'})
  const {currentUser} = useContext(UserContext)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)

  const handleCloseNotifications = () => {
    setShowNotifications(false)
  }

  return (
    <div className="scrollbar-hide flex overflow-scroll h-screen relative">
      {/* Sidebar */}
      <div
        className={`h-screen fixed top-0 left-0 z-50 w-full bg-gray-800 ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:relative lg:translate-x-0 lg:w-auto`}
      >
        <Sidebar
          setIsSidebarOpen={setIsSidebarOpen}
          user={user || currentUser}
          showNotifications={showNotifications}
          setShowNotifications={setShowNotifications}
        />
      </div>

      {/* Overlay for mobile (when sidebar is open) */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className=" overflow-x-hidden flex-1 h-screen overflow-y-scroll">
        <div
          className="fixed top-0 z-50 py-6 w-full px-4 cursor-pointer text-white flex justify-between bg-primary-blue lg:hidden"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <img src={logo} alt="logo" className="w-[94px]"></img>
          {isSidebarOpen ? (
            <img src={closeIcon} alt="close"></img>
          ) : (
            <img src={hamburgerIcon} alt="menu"></img>
          )}
        </div>
        <div className="mt-20 lg:mt-0">
          {children || <Outlet />}
          {showNotifications && (
            <NotificationsSidebar
              isOpen={showNotifications}
              onClose={handleCloseNotifications}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Layout
